'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _MessageFormatter = require('@/libs/MessageFormatter');

var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _ContainerHeader = require('@/components/ContainerHeader.vue');

var _ContainerHeader2 = _interopRequireDefault(_ContainerHeader);

var _UserProfile = require('@/customized-core/UserProfile.vue');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
	mixins: [_ContainerHeader2.default],
	data: function data() {
		return {
			isProfileMenuOpen: false
		};
	},

	computed: {
		nickname: function nickname() {
			return this.network.nick;
		},
		avatarClass: function avatarClass() {
			var nick = this.network.nick.toLowerCase();
			var user = this.network.users[nick] || null;
			if (!user || !user.gender || !user.targetGender) {
				return "kiwi-avatar--default";
			}
			var avatar = user.gender.charAt(0) + user.targetGender.charAt(0);
			if (["mm", "mw", "mo", "mt", "fw", "fm", "fo", "ft", "om", "ow", "ot", "oo", "tm", "tw", "to", "tt"].includes(avatar)) {
				return "kiwi-avatar--" + avatar;
			}
			return "kiwi-avatar--default";
		}
	},
	methods: {
		toggleProfile: function toggleProfile() {
			if (this.sidebarState.isOpen) {
				this.sidebarState.close();

				if (this.sidebarState.activeComponent === _UserProfile2.default) {
					this.sidebarState.activeComponent = null;
					return;
				}
			}

			_GlobalApi2.default.singleton().showInSidebar(_UserProfile2.default);
			this.isProfileMenuOpen = false;
			this.sidebarState.sidebarOpen = true;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/ContainerHeader.vue
// module id = jyom
// module chunks = 1